(ns renolit-roofing-service.view.installer-add-review-popup
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form :as layout.form]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.service.service :as srv.service]
            [renolit-roofing-service.shared.domain.types :as dom.types]
            [renolit-roofing-service.tooltip :as tooltip]
            [renolit-roofing-service.tooltip.generic-popup :as tooltip.generic-popup]))

(def ^:const view-context ::add-review)

(def ^:const popup-id tooltip.generic-popup/default-popup-id)

(defn- choice-display-fn
  [{:keys [label-transl-kw]}]
  (t [label-transl-kw]))

(defn- initial-state
  []
  {:zone-id nil
   :wp nil
   :wp-type nil
   :task-type nil
   :comment ""})

(defn- zone-choices
  []
  (let [service @(rf/subscribe [::srv.service/current-service])
        zones (or (:zones service) [])]
    (mapv (fn [zone]
            {:id (:id zone)
             :label-transl-kw nil
             :label (:name zone)})
          zones)))

(defn- zone-display-fn
  [{:keys [label]}]
  label)

(defn- valid-form?
  [state]
  (and (:zone-id state)
       (:wp state)
       (:wp-type state)
       (:task-type state)))

(defn- main*
  [{:keys [service-id]}]
  (let [state (r/atom (initial-state))]
    (fn []
      (let [{:keys [wp wp-type]} @state
            zones (zone-choices)
            wp-choices (dom.types/get-dropdown-values :wp)
            wp-type-ids (when wp (keys (get dom.types/wp-hierarchy wp)))
            wp-type-choices (when wp (dom.types/get-dropdown-values :wp-type wp-type-ids))
            task-ids (when (and wp wp-type) (get-in dom.types/wp-hierarchy [wp wp-type]))
            task-choices (when task-ids (dom.types/get-dropdown-values :task-type task-ids))]
        [:<>
         [tooltip.generic-popup/generic-popup-header
          {:title-transl-kw :page.installer.add-review-popup/title
           :popup-id popup-id}]
         [:div.add-observation-popup
          [layout.form/item
           {:context view-context
            :type :advanced-select-with-fixed-choices
            :search? false
            :multi? false
            :mandatory? true
            :state state
            :path [:zone-id]
            :attribute-path [:options :zone-id]
            :schema [:uuid]
            :choices zones
            :choice-display-fn zone-display-fn
            :label-transl-kw :page.installer.add-review-popup/zone
            :placeholder-transl-kw :form.advanced-select/select}]
          [layout.form/item
           {:context view-context
            :type :advanced-select-with-fixed-choices
            :search? false
            :multi? false
            :mandatory? true
            :state state
            :path [:wp]
            :attribute-path [:options :wp]
            :schema [:keyword]
            :choices wp-choices
            :choice-display-fn choice-display-fn
            :label-transl-kw :page.installer.add-review-popup/wp
            :placeholder-transl-kw :form.advanced-select/select
            :on-change {:fn (fn [_]
                              (swap! state assoc :wp-type nil :task-type nil))}}]
          [layout.form/item
           {:context view-context
            :type :advanced-select-with-fixed-choices
            :search? false
            :multi? false
            :mandatory? true
            :disabled? (not wp)
            :state state
            :path [:wp-type]
            :attribute-path [:options :wp-type]
            :schema [:keyword]
            :choices (or wp-type-choices [])
            :choice-display-fn choice-display-fn
            :label-transl-kw :page.installer.add-review-popup/wp-type
            :placeholder-transl-kw :form.advanced-select/select
            :on-change {:fn (fn [_]
                              (swap! state assoc :task-type nil))}}]
          [layout.form/item
           {:context view-context
            :type :advanced-select-with-fixed-choices
            :search? false
            :multi? false
            :mandatory? true
            :disabled? (not (and wp wp-type))
            :state state
            :path [:task-type]
            :attribute-path [:options :task-type]
            :schema [:keyword]
            :choices (or task-choices [])
            :choice-display-fn choice-display-fn
            :label-transl-kw :page.installer.add-review-popup/task
            :placeholder-transl-kw :form.advanced-select/select}]
          [layout.form/item
           {:context view-context
            :type :text-area
            :state state
            :path [:comment]
            :schema [:string]
            :label-transl-kw :page.installer.add-review-popup/comment
            :input-opts {:rows 3}}]]
         [:div.add-observation-popup__footer
          [:button.btn.btn--primary.btn--full-width
           {:type "button"
            :disabled (not (valid-form? @state))
            :on-click (fn []
                        (when (valid-form? @state)
                          (let [{:keys [zone-id wp wp-type task-type comment]} @state
                                review {:id (random-uuid)
                                        :type :general
                                        :zone-id zone-id
                                        :wp wp
                                        :wp-type wp-type
                                        :tasks [{:task-type task-type
                                                 :comment comment}]}]
                            (rf/dispatch [::srv.service/append-service-review
                                          service-id review
                                          {:on-success-evt [::close]}]))))}
           (t [:page.installer.add-review-popup/save])]
          [:button.flat-btn.add-observation-popup__cancel-btn
           {:type "button"
            :on-click #(rf/dispatch [::close])}
           (t [:page.installer.add-review-popup/cancel])]]]))))

(defn- main
  [opts]
  [main* opts])

(rf/reg-event-fx
 ::close
 (fn [_]
   {:fx [[:dispatch [::form.error/clear-errors view-context]]
         [:dispatch [::tooltip/destroy-by-id {:id popup-id}]]]}))

(rf/reg-event-fx
 ::open
 (fn [_ [_ opts]]
   {:fx [[:dispatch [::tooltip/register {:id popup-id
                                         :on-destroy-evt [::close]
                                         :component main
                                         :argv [opts]
                                         :class ["generic-popup-standard"]}]]]}))
